export async function submitAfterTimeOver({ showAlert, submit, onFailed }) {
  await showAlert();
  const isSent = await submit();
  if (!isSent) {
    onFailed();
  }
  return isSent;
}
